import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { coins_earned_vs_spent } from "../../data/ApiEndpoints";
import { useGetFetch, useGetFetchNew } from "../../data/Queries";
import { Tab, TabList, Tabs, TabPanel } from "react-tabs";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const CoinsEarnedVsSpentChart = ({ userInfoData, gymId }) => {
  const [chartData, setChartData] = useState(null);
  const [activeTab, setActiveTab] = useState("coins");
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

  // Fetch Data with Filters
  const { data, isLoading, refetch } = useGetFetchNew({
    token: userInfoData?.token,
    key: "coins_earned_vs_spent",
    url: `${coins_earned_vs_spent}`,
    filters: {
      year: selectedYear,
      gym_id: gymId || "",
    },
  });

  useEffect(() => {
    if (data?.status) {
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sept",
        "Oct",
        "Nov",
        "Dec",
      ];

      setChartData(
        data?.data?.map((item) => ({
          month: months[item.month - 1],
          earn_coin: parseInt(item.earn_coin),
          spent_coin: parseInt(item.spent_coin),
          earn_inr_value: parseFloat(item.earn_inr_value),
          spent_inr_value: parseFloat(item.spent_inr_value),
        }))
      );
    }
  }, [data]);

  // Handle Year Change & Refetch Data
  const handleYearChange = (e) => {
    setSelectedYear(e.target.value);
    // refetch();
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
        labels: { color: "#000" },
      },
      title: {
        display: true,
        text: "Coins Earned Vs Spent",
        font: {
          size: window.innerWidth > 768 ? 24 : 18,
          weight: "bold",
        },
      },
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: {
          maxRotation: 0,
          minRotation: 0,
        },
      },
      y: {
        beginAtZero: true,
        ticks: {
          callback: (value) => `${value / 1000}k`,
        },
      },
    },
    barThickness: 8,
    maxBarThickness: 10,
    barPercentage: 0.4,
    categoryPercentage: 0.8,
  };

  useEffect(() => {
    refetch();
  }, [selectedYear, refetch, gymId]);

  if (isLoading) return <p>Loading...</p>;

  return (
    <div className="coinsEarnedVsSpentChart" style={{ padding: "20px" }}>
      <div
        style={{
          gap: "15px",
          marginBottom: "20px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <label
            style={{
              fontWeight: "bold",
              color: "#333",
              minWidth: "100px",
            }}
          >
            Select Year:{" "}
          </label>
          <select
            value={selectedYear}
            onChange={handleYearChange}
            style={{
              padding: "8px 12px",
              borderRadius: "6px",
              border: "1px solid #ddd",
              backgroundColor: "#fff",
              cursor: "pointer",
              fontSize: "14px",
              minWidth: "120px",
            }}
          >
            {Array.from({ length: 10 }, (_, i) => {
              const year = new Date().getFullYear() - i;
              return (
                <option key={year} value={year}>
                  {year}
                </option>
              );
            })}
          </select>
        </div>

        <br />

        <div className="tab__Border">
          <Tabs
            selectedIndex={activeTab === "coins" ? 0 : 1}
            onSelect={(index) => setActiveTab(index === 0 ? "coins" : "inr")}
          >
            <TabList
              style={{
                display: "flex",
                margin: 0,
                padding: 0,
              }}
            >
              <Tab>Coins</Tab>
              <Tab>INR</Tab>
            </TabList>
          </Tabs>
        </div>
      </div>
      {chartData && (
        <div
          style={{
            height: "450px",
            width: "100%",
            backgroundColor: "#fff",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          }}
        >
          <Bar
            data={{
              labels: chartData.map((item) => item.month),
              datasets: [
                {
                  label: "Spent",
                  data: chartData.map((item) =>
                    activeTab === "coins"
                      ? item.spent_coin
                      : item.spent_inr_value
                  ),
                  backgroundColor: "red",
                  borderRadius: 4,
                  barThickness: 60, // Further increased column width
                  maxBarThickness: 60, // Increased maximum width constraint
                },
                {
                  label: "Earned",
                  data: chartData.map((item) =>
                    activeTab === "coins" ? item.earn_coin : item.earn_inr_value
                  ),
                  backgroundColor: "green",
                  borderRadius: 4,
                  barThickness: 60, // Further increased column width
                  maxBarThickness: 60, // Increased maximum width constraint
                },
              ],
            }}
            options={options}
          />
        </div>
      )}
    </div>
  );
};

export default CoinsEarnedVsSpentChart;
